import React from 'react';

import "./Forms.scss";
import { Link } from 'react-router-dom';
import Button from './Button';

const StickyButton = (props) => {
    const { link = '' } = props
    const isDisabled = props.isDisabled ? 'disabled' : ''
    return (
        <div className='sticky-button-block'>
            {!link ?
                <Button isDisabled={props.isDisabled} handlClick={props.handleClick}>
                    {props.label}
                </Button>
                :
                <Link to={props.link} className={`button-link ${isDisabled}`} onClick={props.handleClick}>
                    {props.label}
                </Link>
            }
        </div>
    )
}
export default StickyButton;